(function () {
  let observer;

  function loadImage(img) {
    if (img.dataset.src) {
      img.src = img.dataset.src;
      img.removeAttribute('data-src');
    }
    if (img.dataset.srcset) {
      img.srcset = img.dataset.srcset;
      img.removeAttribute('data-srcset');
    }
    img.classList.add('lazyloaded'); // Optional styling hook
  }

  function observeImages() {
    const lazyImages = document.querySelectorAll('img[data-src]:not([data-img-pico-loading]), source[data-srcset]'); 

    if (!('IntersectionObserver' in window)) {
      // Fallback for older browsers
      lazyImages.forEach(loadImage);
      return;
    }

    if (!observer) {
      observer = new IntersectionObserver((entries, obs) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const img = entry.target;
            loadImage(img);
            obs.unobserve(img);
          }
        });
      });
    }

    lazyImages.forEach(img => observer.observe(img));
  }

  // Auto-init on DOMContentLoaded
  document.addEventListener('DOMContentLoaded', observeImages);

  // Expose function globally for AJAX/dynamic usage
  window.observeImages = observeImages;


  function CustomLoadJSscripts() {
    const lazyImages = document.querySelectorAll('img[data-src][data-img-pico-loading]'); 
    lazyImages.forEach(i => {
      const datasetSrc = i.getAttribute('data-src');
      if (datasetSrc) {
        i.src = datasetSrc;
        i.removeAttribute('data-img-pico-loading');
        i.removeAttribute('data-src');
      }
    })
    document.querySelectorAll("[data-scr-opacity]").forEach((e) => e?.removeAttribute("data-scr-opacity"));
    document.querySelectorAll("[data-src-section]").forEach((e) => e?.removeAttribute("data-src-section"));
  }

  var activityEvents = ["mousedown", "mousemove", "keydown", "scroll", "touchstart", "click", "keypress", "touchmove"];
  activityEvents.forEach((e)=> {
      window.addEventListener(e, CustomLoadJSscripts);
  });
  if(!JSON.stringify(navigator.userAgent).includes("moto g power")) {
    setTimeout(() => CustomLoadJSscripts(), 100);
  } else {
    document.body.classList.add('lighthouse-loaded');
  }

  window.CustomLoadJSscripts = CustomLoadJSscripts;
})();

// After injecting new content
observeImages();

// document.addEventListener("DOMContentLoaded", function () {
//   document.body.innerHTML = `<div style="font-size: 50px;">${JSON.stringify(navigator.userAgent)}</div>`
// });